import type { RootState } from '@/store';
import type { IAvailabilityState } from '@/store/types';

import { getAvailability } from '../slices/availabilitySlice';

const emptyAvailabilityList: IAvailabilityState['availabilityList'] = [];
export const selectAvailabilityList = (state: RootState): NonNullable<IAvailabilityState['availabilityList']> =>
  state.availability.availabilityList ?? emptyAvailabilityList;
export const selectIsAvailabilityListLoading = (state: RootState): boolean =>
  state.availability.availabilityList === null || selectIsPendingAction(getAvailability.typePrefix)(state);
const emptyLastAvailabilityList: IAvailabilityState['availabilityList'] = [];
export const selectLastAvailabilityList = (state: RootState): NonNullable<IAvailabilityState['lastAvailabilityList']> =>
  state.availability.lastAvailabilityList ?? emptyLastAvailabilityList;
export const selectLastParsedData = (state: RootState): IAvailabilityState['lastParsedData'] =>
  state.availability.lastParsedData;
export const selectParsedAvailabilityData = (state: RootState): IAvailabilityState['parsedAvailabilityData'] =>
  state.availability.parsedAvailabilityData;
export const selectAvailabilityBasket = (state: RootState): IAvailabilityState['availabilityBasket'] =>
  state.availability.availabilityBasket;

/**
 * Meta
 */
export const selectIsPending = (state: RootState): boolean => Boolean(state.availability.meta.pending.length);
export const selectIsPendingAction =
  (actionType: string) =>
  (state: RootState): boolean =>
    state.availability.meta.pending.some(action => action === actionType);
